import { render } from "./PaymentButton.vue?vue&type=template&id=425d785a"
import script from "./PaymentButton.vue?vue&type=script&lang=js"
export * from "./PaymentButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__